module.exports = __webpack_public_path__ + "static/media/mentorship.feb08377.svg";